<!--
  대시보드 종합
  종합 상황판 위젯

  @since: 2018-08-10
  @author: mk.ko
-->

<template>
  <div ref="widgetWrapper"
       class="widget-wrapper pad0">
    <div class="widget-contents">
      <div class="widget-contents-wrapper">

        <!-- 컨텐츠 시작 -->
        <q-carousel ref="widgetCarousel"
                    :height="`${widgetHeight}px`"
                    :infinite="true"
                    :arrows="true"
                    :autoplay="true"
                    :quick-nav="false"
                    class="status-carousel">
          <template v-for="(item, index) in widgetData">
            <q-carousel-slide class="status-carousel-slide pad0" v-if="item.visible">

              <div class="status-content-now">

                <svg preserveAspectRatio="none" :viewBox="viewBox" width="100%" height="100%">
                  <g>
                    <defs>
                      <filter id="shadow" x="-5" y="-5" width="140%" height="140%">
                        <feGaussianBlur stdDeviation="2 2" result="shadow"/>
                        <feOffset dx="6" dy="6"/>
                      </filter>
                    </defs>
                    <defs>
                      <filter id="glow" x="-10%" y="-10%" width="140%" height="140%">
                        <feGaussianBlur stdDeviation="1 1" result="glow"/>
                        <feMerge>
                          <feMergeNode in="glow"/>
                          <!--<feMergeNode in="glow"/>-->
                          <!--<feMergeNode in="glow"/>-->
                        </feMerge>
                      </filter>
                    </defs>
                    <circle r="100" cx="50%" cy="45%" :class="['content-circle', `fill-${(index)}`]" />
                    <text x="50%" y="45%" :class="['content-type', `fill-${(index)}`]" style="filter: url(#glow);">{{item.name}}</text>
                    <!--<text x="50%" y="45%" class="content-type fill-gray" style="filter: url(#glow);">{{item.name}}</text>-->
                    <text x="50%" y="45%" class="content-type fill-white">{{item.name}}</text>
                    <!--<text x="50%" y="60%" :class="['content-value', `fill-${(index)}`]" style="filter: url(#glow);">{{byteConverter(item.value, 1)}}</text>-->
                    <template v-if="item.scale === 1">
                      <!--<text x="50%" y="60%" class="content-value fill-gray" style="filter: url(#glow);">{{byteConverter(item.value, 1)}}</text>-->
                      <text x="50%" y="60%" class="content-value fill-white">{{byteConverter(item.value, 1)}}{{ restData.unit_time }}</text>
                    </template>
                    <template v-else>
                      <!--<text x="50%" y="60%" class="content-value fill-gray" style="filter: url(#glow);">{{getScale(item.value, 1)}}</text>-->
                      <text x="50%" y="60%" class="content-value fill-white">{{getScale(item.value, 1)}}{{ restData.unit_time }}</text>
                    </template>

                  </g>
                </svg>

              </div>

              <div class="status-content-before">
                <span class="content-value">
                  <span class="content-value-time"><i class="material-icons">access_time</i> {{ $t('cmn.previous') }}:</span>
                  <template  v-if="item.scale === 1">{{byteConverter(item.prevValue, 1)}}{{ restData.unit_time }}</template>
                  <template  v-if="item.scale === 2">{{getScale(item.prevValue, 1)}}{{ restData.unit_time }}</template>
                </span>

                <span class="content-increase">
                  <span class="content-increase-up" v-if="item.increase > 0">
                    <span >&#x25B2;</span> <!-- Up Triangle -->
                    <span class="content-ratio">{{getScale(item.ratio, 0)}}%</span>
                  </span>

                  <span class="content-increase-down" v-if="item.increase < 0">
                    <span v-if="item.value < item.prevValue">&#x25BC;</span> <!-- Down Triangle -->
                    <span class="content-ratio">{{getScale(Math.abs(item.ratio), 0)}}%</span>
                  </span>

                  <span class="content-increase-equal" v-if="item.increase === 0">
                    <span >&#x2796;</span> <!-- Minus -->
                    <span class="content-ratio">{{getScale(item.ratio, 0)}}%</span>
                  </span>
                </span>

              </div>

            </q-carousel-slide>
          </template>

        </q-carousel>
        <!-- 컨텐츠 row 끝 -->

        <!--컬럼 설정 팝업-->
        <!--<content-set-popup ref="contentsDialog"-->
                           <!--id="contentsDialogPopup"-->
                           <!--:content="contents"></content-set-popup>-->
        <contents-dialog ref="contentsDialog"
                         :contents="widgetData"
                         :match-use-key="'visible'"
                         :match-id-key="'key'"
                         @apply="onColumnChange" />
      </div>
    </div>
  </div>
</template>

<script>
  // Mixin 객체
  import { widgetMixin } from '~/mixins/widgetCommonMixin'
  import valueMixin from '~/mixins/value/commonValueMixin'
  // 컨텐츠 설정 팝업
  import ContentSetPopUp from '~/components/popUp/ContentSetPopUp'
  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'
  // 스토어 헬퍼 객체
  const { mapState, mapActions } = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetGeneralStatus',
    components: {
      'contents-dialog': ContentSetPopUp
    },
    directives: {},
    mixins: [ widgetMixin, valueMixin ],
    data () {
      return {
        w: 1,
        title: 'widgetGeneralStatus',
        isLock: false,
        isMove: true,
        isResize: false,
        isMaximum: false,
        eventBus: true,
        deviceType: [20, 21, 23],
        // isIpType: true,
        widgetData: [],
        init: true,
        restData: {
          result: [],
          unit_time: ''
        },
        opts: {
          visibleKeys: []
        },
        contentsKeys: ['total_bytes', 'deny_bytes', 'allow_bytes', 'security_cnt'],

        // Carousel 관련 변수
        widgetHeight: 0,
        widgetWidth: 0,
        viewBox: '0 0 0 0'
      }
    },
    computed: {
      ...mapState([
        'filterDate'
      ]),
      locale () {
        return this.$store.state.common.locale.locale
      },
      widgetCustomMenu () {
        try {
          // TAMS, 해당 메뉴 권한이 있을 경우만 (쓰기 권한)
          if (!this.thisMenuPermission) {
            return []
          } else {
            return [
              {
                key: 'menu_contents_settings',
                icon: 'q-icon q-chart-icon icon-chart-settings',
                label: this.$t('dash.contentsSettings'),
                click: this.openContentsSettingPopup
              }
            ]
          }
        } catch (e) {
          this.$log('[Widget General Status GUI error (widgetCustomMenu)]', e)
          return []
        }
      }
    },
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          widgetType: 'tams_summary'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.machId) {
            contentsOptions.machId = extraParams.machId
          }
        }

        try {
          // Progress 출력 여부
          this.showProgress(true)

          // 초기화
          this.widgetData = []

          // 설정된 컨텐츠가 없으면
          if (this.opts.visibleKeys.length === 0) {
            this.opts.visibleKeys = _.cloneDeep(this.contentsKeys)
          }

          // IP Type filter 추가
          if (this.opts.ipType) {
            contentsOptions.ipType = this.opts.ipType
          }
          // 장비 filter 추가
          if (this.opts.mach_id) {
            contentsOptions.machId = this.opts.mach_id
          }
          // 엑스트라 파라미터가 있는 경우 (IP Type / Device Type / HA Mamber를 선택하여 데이터를 다시 불러와야 하는 경우)
          if (extraParams) {
            if (extraParams.ipType) {
              contentsOptions.ipType = extraParams.ipType
            }
            if (extraParams.machId) {
              contentsOptions.machId = extraParams.machId
            }
          }

          // IP Type을 String 값을 Number 값으로 치환.
          if (_.has(contentsOptions, 'ipType')) {
            let ipType = contentsOptions.ipType
            contentsOptions.ipType = _.head(_.filter(this.ipTypeList, {'value': ipType})).ipType
          }

          // 0. API 호출
          const {code, result} = await this.getWidgetData(contentsOptions)

          if (code === 'ok') {
            if (_.get(result, ['result', 'length'], 0) > 0) {
              // Rest data 초기화
              this.restData = result

              const prefixBefore = 'before_', // NGF: before_, IPS: ips_before_
                summaryData = this.restData.result[0]
              let contentsData = []

              this.contentsKeys.forEach(key => {
                const value = parseInt(summaryData[key]),
                  prevValue = parseInt(summaryData[`${prefixBefore}${key}`])
                let ratio, increase

                if (value > prevValue && prevValue !== 0) {
                  ratio = (value - prevValue) / prevValue * 100
                  increase = 1
                } else if (prevValue > value && prevValue !== 0) {
                  ratio = (prevValue - value) / prevValue * 100
                  increase = -1
                } else {
                  ratio = 0
                  increase = 0
                }

                contentsData.push({
                  key: key,
                  name: this.$t(`dash.widgetSummary_${key}`),
                  scale: key.indexOf('_bytes') !== -1 ? 1 : 2,
                  value: value,
                  prevValue: prevValue,
                  ratio: ratio,
                  increase: increase,
                  visible: this.opts.visibleKeys.indexOf(key) !== -1
                })
              })

              this.widgetData = contentsData
            }

            this.$refs.widgetCarousel.goToSlide()
          }

          // Progress 출력 여부
          this.showProgress(false)
        } catch (e) {
          this.showProgress(false)
          this.$log('[Widget General Status GUI Error (getWidgetContentsData)]', e)
        }
      },
      onResize () {
        const height = this.$refs.widgetWrapper.clientHeight
        const width = this.$refs.widgetWrapper.clientWidth

        this.widgetHeight = height
        this.widgetWidth = width

        this.viewBox = `0 0 ${width} ${height}`
      },
      openContentsSettingPopup () {
        this.$nextTick(() => {
          this.$refs.contentsDialog.show()
        })
      },
      onColumnChange ({ selectedKeys }) {
        this.opts.visibleKeys = _.cloneDeep(selectedKeys)

        this.getWidgetContentsData()
      },
      getScale (value, fixed) {
        return this.kmgtConverter(value, fixed)
      }
    },
    beforeCreate () {},
    created () {
      window.addEventListener('resize', this.onResize)
    },
    beforeMount () {},
    mounted () {
      this.$nextTick(function () {
        this.onResize()
      })
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    },
    destroyed () {},
    errorCaptured () {},
    watch: {}
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }
</style>
